import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, type OnInit, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';
import { ToggleMenuSite, ToggleOffcanvasSite } from '@stores/site/site.actions';

@Component({
  selector: 'tr-header',
  standalone: true,
  imports: [CommonModule, ButtonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  private store: Store = inject(Store);

  ngOnInit(): void {}

  toggleMenu() {
    this.store.dispatch(new ToggleMenuSite());
  }

  toggleOffcanvas() {
    this.store.dispatch(new ToggleOffcanvasSite());
  }
}
